import React from 'react'
import dayjs from 'dayjs'
import { Tooltip } from 'antd'
import DatePicker from 'react-datepicker'

function ReusableTable({
  title,
  columns,
  data,
  onChange,
  showIndex,
  screenAction,
}) {
  // Kiểm tra có cần header nhóm (có nhóm colSpan hoặc isGroupHeader)
  const hasGroup = columns.some((col) => col.isGroupHeader || col.groupName)

  // Hàm xử lý thay đổi ô input
  const handleCellChange = (rowIndex, key, value) => {
    const updated = [...data]
    updated[rowIndex] = { ...updated[rowIndex], [key]: value }
    onChange(updated)
  }

  // Thêm dòng mới (các trường khởi tạo rỗng)
  const handleAddRow = () => {
    const newRow = {}
    columns.forEach((col) => {
      if (!col.isGroupHeader) {
        newRow[col.key] = ''
      }
    })
    onChange([...(data || []), newRow])
  }

  // Xoá dòng theo index
  const handleDeleteRow = (rowIndex) => {
    const updated = [...data]
    updated.splice(rowIndex, 1)
    onChange(updated)
  }

  return (
    <div>
      <div
        className="d-flex align-items-end font-sfpro-bold"
        style={{ minHeight: '44px', paddingBottom: '8px' }}
      >
        {title}
      </div>
      <div className="digital-certificate">
        <table className="table table-bordered">
          <thead>
            {hasGroup ? (
              <>
                <tr>
                  {showIndex && (
                    <th rowSpan={2} className="index-header">
                      STT
                    </th>
                  )}
                  {columns.map((col) => {
                    if (col.isGroupHeader) {
                      // Tiêu đề nhóm
                      return (
                        <th key={col.key} colSpan={col.colSpan || 1}>
                          {col.title}
                        </th>
                      )
                    } else if (!col.groupName) {
                      // Cột độc lập (không thuộc nhóm)
                      return (
                        <th key={col.key} rowSpan={2}>
                          {col.title}
                        </th>
                      )
                    }
                    return null
                  })}
                  <th
                    scope="col"
                    rowSpan="2"
                    colSpan="1"
                    className="action-header"
                  >
                    {data.length == 0 && (
                      <i
                        className="fal fa-plus mr-4 cursor-pointer mx-auto"
                        onClick={handleAddRow}
                      ></i>
                    )}
                  </th>
                </tr>
                <tr>
                  {columns.map((col) => {
                    if (col.groupName) {
                      // Cột con của nhóm
                      return (
                        <th scope="col" rowSpan="1" colSpan="1" key={col.key}>
                          {col.title}
                        </th>
                      )
                    }
                    return null
                  })}
                </tr>
              </>
            ) : (
              <tr>
                {showIndex && (
                  <th
                    scope="col"
                    rowSpan="2"
                    colSpan="1"
                    className="index-header"
                  >
                    STT
                  </th>
                )}
                {columns.map((col) => (
                  <th scope="col" rowSpan="2" colSpan="1" key={col.key}>
                    {col.title}
                  </th>
                ))}
                <th className="action-header">
                  <button
                    type="button"
                    className="add-row-button"
                    onClick={handleAddRow}
                  >
                    <i
                      className="fal fa-plus mr-4 cursor-pointer mx-auto"
                      onClick={screenAction != 'xem' && handleAddRow()}
                    ></i>
                  </button>
                </th>
              </tr>
            )}
          </thead>
          <tbody>
            {(data || []).map((row, rowIndex) => (
              <tr key={rowIndex}>
                {showIndex && <td className="index-cell">{rowIndex + 1}</td>}
                {columns.map((col) => {
                  if (col.isGroupHeader) return null
                  // Xác định loại input (nếu là ngày tháng)
                  const isDateField = /ng\u00e0y|date/i.test(col.title)
                  const cellValue = row[col.key] || ''
                  const displayValue =
                    isDateField && cellValue
                      ? dayjs(cellValue).format('YYYY-MM-DD')
                      : cellValue
                  return (
                    <td key={col.key}>
                      <Tooltip title={displayValue}>
                        <div
                          style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            wordBreak: 'break-word',
                          }}
                        >
                          {isDateField ? (
                            <DatePicker
                              dateFormat="dd/MM/yyyy"
                              customInput={
                                <input
                                  type="text"
                                  className="form-control input-date"
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 'none',
                                    outline: 'none',
                                  }}
                                />
                              }
                              onChangeRaw={(e) => {
                                const newDate = dayjs(
                                  e?.target?.value?.trim(),
                                  'DD/MM/YYYY',
                                  true,
                                )
                                if (newDate.isValid()) {
                                  handleCellChange(
                                    rowIndex,
                                    col.key,
                                    dayjs(newDate).format('YYYY-MM-DD'),
                                  )
                                }
                              }}
                              todayButton={<button>Hôm nay</button>}
                              readOnly={screenAction == 'xem'}
                              selected={
                                displayValue ? new Date(displayValue) : ''
                              }
                              onChange={(date) => {
                                handleCellChange(
                                  rowIndex,
                                  col.key,
                                  date
                                    ? dayjs(date).format('YYYY-MM-DD')
                                    : null,
                                )
                              }}
                            />
                          ) : (
                            <input
                              type={isDateField ? 'date' : 'text'}
                              value={displayValue}
                              onChange={(e) =>
                                handleCellChange(
                                  rowIndex,
                                  col.key,
                                  e.target.value,
                                )
                              }
                              style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                outline: 'none',
                              }}
                              // className=""
                            />
                          )}
                        </div>
                      </Tooltip>
                    </td>
                  )
                })}
                <td className="action-cell">
                  <div className="d-flex justify-content-space-between gap-3">
                    <i
                      className="fal fa-plus mr-4 cursor-pointer mx-auto"
                      onClick={handleAddRow}
                    ></i>
                    <i
                      className="far fa-trash-alt cursor-pointer"
                      onClick={() => handleDeleteRow(rowIndex)}
                    ></i>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-start mt-2">
          <button type="button" className="btn" onClick={handleAddRow}>
            <i className="fal fa-plus mr-4 cursor-pointer mx-auto"></i>
            Thêm dòng
          </button>
        </div>
      </div>
    </div>
  )
}

export default ReusableTable
